import { IVariant } from 'services/variant';

export type IPurchasedProductState = IVariant & {
  quantity: number;
  unitPrice: number;
};

export enum ActionKind {
  SetPurchasedProducts = 'SET_PURCHASED_PRODUCTS',
  AddPurchasedProduct = 'ADD_PURCHASED_PRODUCT',
  RemovePurchasedProduct = 'REMOVE_PURCHASED_PRODUCT',
  EditPurchasedProduct = 'EDIT_PURCHASED_PRODUCT',
  SetWarehouseId = 'SET_WAREHOUSE_ID',
  SetVat = 'SET_VAT',
  SetShipment = 'SET_SHIPMENT',
  SetDiscount = 'SET_DISCOUNT',
  SetPaidInCash = 'SET_PAID_IN_CASH',
  SetPayNow = 'SET_PAY_NOW',
  SetDue = 'SET_DUE',
}

export type Action =
  | { type: ActionKind.SetPurchasedProducts; payload: IPurchasedProductState[] }
  | { type: ActionKind.AddPurchasedProduct; payload: IPurchasedProductState }
  | { type: ActionKind.RemovePurchasedProduct; payload: string }
  | { type: ActionKind.EditPurchasedProduct; payload: IPurchasedProductState }
  | { type: ActionKind.SetWarehouseId; payload: string }
  | { type: ActionKind.SetVat; payload: number }
  | { type: ActionKind.SetShipment; payload: number }
  | { type: ActionKind.SetDiscount; payload: number }
  | { type: ActionKind.SetPaidInCash; payload: boolean }
  | { type: ActionKind.SetPayNow; payload: boolean }
  | { type: ActionKind.SetDue; payload: boolean };

interface IState {
  purchasedProducts: IPurchasedProductState[];
  warehouseId: string | undefined;
  vat: number;
  shipment: number;
  discountCost: number;
  paidInCash: boolean;
  payNow: boolean;
  fullDue: boolean;
}

export const initialState: IState = {
  purchasedProducts: [],
  warehouseId: undefined,
  vat: 0,
  shipment: 0,
  discountCost: 0,
  paidInCash: true,
  payNow: false,
  fullDue: false,
};

export const productPurchaseReducer = (state: IState, action: Action) => {
  switch (action.type) {
    case ActionKind.SetPurchasedProducts:
      return { ...state, purchasedProducts: action.payload };
    case ActionKind.AddPurchasedProduct:
      const isAlreadyExist = state.purchasedProducts.find(
        (variant) => variant.productVariantId === action.payload.productVariantId
      );
      if (isAlreadyExist) return state;
      return { ...state, purchasedProducts: [...state.purchasedProducts, action.payload] };
    case ActionKind.RemovePurchasedProduct:
      const variants = state.purchasedProducts.filter(
        (variant) => variant.productVariantId !== action.payload
      );
      return { ...state, purchasedProducts: variants };
    case ActionKind.EditPurchasedProduct:
      const modifiedProducts = state.purchasedProducts.map((variant) =>
        variant.productVariantId === action.payload.productVariantId
          ? { ...action.payload }
          : { ...variant }
      );
      return { ...state, purchasedProducts: modifiedProducts };
    case ActionKind.SetWarehouseId:
      return { ...state, warehouseId: action.payload };
    case ActionKind.SetVat:
      return { ...state, vat: action.payload };
    case ActionKind.SetShipment:
      return { ...state, shipment: action.payload };
    case ActionKind.SetDiscount:
      return { ...state, discountCost: action.payload };
    case ActionKind.SetPaidInCash:
      return { ...state, paidInCash: action.payload };
    case ActionKind.SetPayNow:
      return { ...state, payNow: action.payload };
    case ActionKind.SetDue:
      return { ...state, fullDue: action.payload };
    default:
      return state;
  }
};
